"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../../../../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _Fetch = require("./../../../../utils/Fetch");

var _Fetch2 = _interopRequireDefault(_Fetch);

var _ParamsFetch = require("./../../../../utils/ParamsFetch");

var _ParamsFetch2 = _interopRequireDefault(_ParamsFetch);

var _JsonFetch = require("./../../../../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

var _generateUrl = require("./../../../../utils/generateUrl");

var _generateUrl2 = _interopRequireDefault(_generateUrl);

var _UpdateMethods = require("./../UpdateMethods");

var UpdateMethods = _interopRequireWildcard(_UpdateMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Serviska pro práci s objekty. Generated from cz.marbes.api.objekt.v1.ObjektService.
 */
// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2024-04-03T14:22:21Z                      #

// ##############################################################

var ObjektApi = function () {
  function ObjektApi() {
    (0, _classCallCheck3.default)(this, ObjektApi);
  }

  (0, _createClass3.default)(ObjektApi, null, [{
    key: "findObjektFulltext",

    /**
     * Najde objekty dle předaných parametrů. @param fulltextQuery fulltextový dotaz @param obecKod omezení hledání za kód obce @param katastralniUzemiKod omezení hledání za kód katastrálního území @param zakladniTypSet omezení hledání dle záklaního typu objektu @param typKodSet omezení hledání dle kódů typů objektů @param zdrojSet omezení hledání na zdroj dat @param maxCount omezení počtu vrácených záznamů @return nalezené objekty
     *
     * @param query 
     * @param obec 
     * @param ku 
     * @param zaklTyp 
     * @param typ 
     * @param max 
     * @return java.util.List<cz.marbes.api.objekt.v1.ObjektSearchResult>
     */
    value: function findObjektFulltext(query, obec, ku, zaklTyp, typ, max) {
      var uri = serverContextPath + "/api/objekt/v1/objekty";
      var headers = undefined;
      var params = { query: query, obec: obec, ku: ku, zaklTyp: zaklTyp, typ: typ, max: max };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }
  }]);
  return ObjektApi;
}();

exports.default = ObjektApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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